export enum DeleteOrgEvent {
    DialogOpened = 'Delete Org Dialog Opened',
    ButtonClicked = 'Delete Org Button Clicked',
    ConfirmSubmitted = 'Delete Org Confirm Submitted',
    ReasonCancelled = 'Delete Org Reason Cancelled',
    ReasonSubmitted = 'Delete Org Reason Submitted',
    ConfirmCancelled = 'Delete Org Confirm Cancelled',
}
